import { toNumber } from 'lodash'
import moment from 'moment'
import { isEmpty, equals } from 'ramda'
import { generateCampaignDeeplink } from '@/models/listing/ports'
import { getAreaMeasurementLabel } from '@/utils/listings'

const equalsOne = equals('1')

export const getCampaignDeeplink = async (campaign, listingId) => {
  const { response, body } = await generateCampaignDeeplink({
    campaign,
    listingId
  })
  if (response.ok) return body.url
}

export const getListingTypeText = (type, scope) => {
  const listingTypes = {
    condo: {
      entire: 'Entire Apartment',
      partial: 'Partial Apartment',
      single: 'Private Room in Apartment'
    },
    house: {
      entire: 'Entire House',
      partial: 'Partial House',
      single: 'Private Room in House'
    },
    townhouse: {
      entire: 'Entire Townhouse',
      partial: 'Partial Townhouse',
      single: 'Private Room in Townhouse'
    }
  }
  return listingTypes[type][scope]
}

const hideUnitNumber = listing => !!Number(listing.hide_unit_number)

export const unitHidden = listing => hideUnitNumber(listing) || !listing.unit_number

const streetNoHidden = listing =>
  hideUnitNumber(listing) && listing?.building?.building_type_txt_id === 'house'

export const streetName = listing =>
  streetNoHidden(listing) ? listing?.building?.street_name : listing?.building?.full_street_name

export const formatListingAddress = listing => {
  const { unit_number, building } = listing
  const showBuildingName = !isEmpty(unit_number) && building.name !== building.street_name
  return `${showBuildingName ? building.name + ' ' : ''}${streetName(listing)}`
}

export const getFurnished = listing => {
  if (listing.furnished === '') return 'Furniture available'
  return equalsOne(listing.furnished) ? 'Furnished' : 'Unfurnished'
}

export const renderAvailability = listing => {
  const isTodayOrPast = moment().diff(listing.availability_date) >= 0
  return isTodayOrPast ? 'Available now' : moment(listing.availability_date).format('MMMM Do YYYY')
}

export const getBedrooms = (listing, areaMeasurementUnit) => {
  const sizeLabel = getAreaMeasurementLabel(areaMeasurementUnit)
  if (listing.unit_type_scope_txt_id === 'single') return `${listing.size} ${sizeLabel} bedroom`
  const count = toNumber(listing.count_bedrooms)
  if (count === 0) return 'Studio'
  return `${count} bedroom`
}

export const formatFee = (data, feeLabel) => {
  if (isEmpty(data.fee_frequency_txt_id) || data.fee_frequency_txt_id === 'not_available') {
    return null
  }
  if (data.fee_frequency_txt_id === 'free') {
    return `${feeLabel} included`
  }
  return `Paid ${feeLabel} available`
}
